import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.createCannyAccount()
  }

  createCannyAccount () {
    fetch('/dashboard/external_posts/create_canny_account', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getMetaValue('csrf-token')
      },
      body: JSON.stringify({})
    })
  }

  getMetaValue (name) {
    const element = document.querySelector(`meta[name="${name}"]`)
    return element && element.getAttribute('content')
  }
}
